module.exports = __webpack_public_path__ + "static/media/Check.8f14f425.svg";